export const extractScheduleNames = (callFlow) => {
    const scheduleNames = [];
    const scheduleNameMatches = callFlow.match(/ScheduleName:\s*([^;,\n]*)/g);
    if (scheduleNameMatches) {
        scheduleNameMatches.forEach((match) => {
            const scheduleName = match.replace(/^ScheduleName:\s*/, "").trim();
            if (scheduleName && !scheduleNames.includes(scheduleName)) {
                scheduleNames.push(scheduleName);
            }
        });
    }
    return scheduleNames;
};
export const extractFlowPattern = (callFlow, finalAction) => {
    if (!callFlow)
        return `Unknown → ${finalAction}`;
    const steps = [];
    const menuSections = callFlow.split("Processing Prompt Card:").slice(1);
    menuSections.forEach((section) => {
        var _a;
        const menuName = (_a = section.split(",")[0]) === null || _a === void 0 ? void 0 : _a.trim();
        if (menuName) {
            steps.push(menuName);
        }
    });
    if (callFlow.includes("Transferred to PText")) {
        steps.push("Agent Transfer");
    }
    steps.push(finalAction || "Unknown");
    return steps.join(" → ");
};
export const getCompactCallFlow = (interaction) => {
    const parts = [];
    if (interaction.CallFlow) {
        const callFlow = interaction.CallFlow;
        const menuSections = callFlow.split("Processing Prompt Card:").slice(1);
        menuSections.forEach((section) => {
            var _a;
            const menuName = (_a = section.split(",")[0]) === null || _a === void 0 ? void 0 : _a.trim();
            if (menuName) {
                parts.push(menuName);
            }
        });
        if (callFlow.includes("Transferred to PText")) {
            parts.push("Agent Transfer");
        }
    }
    if (interaction.ToFilterOriginator) {
        parts.push(interaction.ToFilterOriginator);
    }
    if (interaction.InteractionFinalAction) {
        parts.push(interaction.InteractionFinalAction);
    }
    if (parts.length === 0)
        return "No routing data";
    const fullFlow = parts.join(" → ");
    if (parts.length <= 4) {
        return fullFlow;
    }
    const endParts = parts.slice(-5);
    return `...→ ${endParts.join(" → ")}`;
};
//# sourceMappingURL=callFlowUtils.js.map